import React from "react";
import { MapPin, CheckCircle2 } from "lucide-react";

const areas = [
  { name: "Morumbi", note: "Atendimento prioritário" },
  { name: "Campo Limpo", note: "Cobertura completa 24h" },
  { name: "Vila Andrade", note: "Equipe local" },
  { name: "Taboão da Serra", note: "Resposta rápida" },
  { name: "Vila Olímpia", note: "Atendimento expresso" },
  { name: "Itaim Bibi", note: "Cobertura completa 24h" },
  { name: "Moema", note: "Equipe local" },
  { name: "Saúde", note: "Resposta rápida" },
  { name: "Interlagos", note: "Atendimento prioritário" },
];

export default function Areas() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative py-24 lg:py-32 bg-black"
    >
      <div className="absolute inset-0 speed-lines opacity-40"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#f3bd0e]/40 rounded-sm mb-5">
              <span className="w-1.5 h-1.5 bg-[#f3bd0e]"></span>
              <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#f3bd0e]">
                Cobertura
              </span>
            </div>
            <h2
              className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight text-white"
              data-testid="areas-title"
            >
              Onde a JR <span className="text-[#f3bd0e]">atende</span>
            </h2>
            <p className="mt-5 text-white/70 leading-relaxed max-w-xl">
              Atendemos com agilidade as principais regiões da Zona Sul de São
              Paulo e da região metropolitana — Morumbi, Campo Limpo, Vila
              Andrade, Taboão da Serra, Vila Olímpia, Itaim Bibi, Moema, Saúde
              e Interlagos. Não está na lista? Entre em contato — geralmente
              conseguimos atender regiões próximas também.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
              {areas.map((a, idx) => (
                <div
                  key={a.name}
                  data-testid={`area-${idx}`}
                  className="group flex items-center gap-3 p-4 bg-[#0A0A0A] border border-white/10 rounded-md hover:border-[#f3bd0e] hover:bg-[#0e0e0e] transition"
                >
                  <MapPin className="w-5 h-5 text-[#f3bd0e]" />
                  <div>
                    <div className="font-display text-base uppercase tracking-tight text-white">
                      {a.name}
                    </div>
                    <div className="text-[11px] uppercase tracking-wider text-white/50">
                      {a.note}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-2 text-sm text-white/60">
              <CheckCircle2 className="w-4 h-4 text-[#f3bd0e] mt-0.5 shrink-0" />
              <span>E também regiões próximas — consulte pelo WhatsApp.</span>
            </div>
          </div>

          {/* Real map block */}
          <div className="relative" data-testid="areas-map">
            <div className="absolute -inset-4 bg-[#f3bd0e]/10 blur-3xl rounded-full"></div>
            <div className="relative bg-[#0A0A0A] border border-white/10 rounded-lg p-3 sm:p-4 overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-1 warning-tape z-10"></div>
              <div className="aspect-[4/3] sm:aspect-[5/4] relative bg-[#050505] rounded-md overflow-hidden border border-white/5">
                <iframe
                  title="Mapa das áreas de atendimento JR Auto Socorro 24h"
                  src="https://maps.google.com/maps?q=Morumbi%2C%20S%C3%A3o%20Paulo%2C%20SP&t=&z=12&ie=UTF8&iwloc=&output=embed"
                  className="absolute inset-0 w-full h-full"
                  style={{ border: 0, filter: "grayscale(0.35) contrast(1.05)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                  data-testid="areas-map-iframe"
                />
                {/* yellow corner badge */}
                <div className="absolute top-3 left-3 z-10 flex items-center gap-2 bg-black/85 backdrop-blur-sm border border-[#f3bd0e]/40 rounded-sm px-3 py-1.5 pointer-events-none">
                  <span className="w-1.5 h-1.5 bg-[#f3bd0e]"></span>
                  <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-white">
                    Zona Sul · SP
                  </span>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between px-2 pb-1">
                <div className="text-[11px] uppercase tracking-[0.25em] text-white/50">
                  9 regiões principais
                </div>
                <div className="flex items-center gap-2 text-[#f3bd0e] text-sm font-bold">
                  <span className="w-2 h-2 bg-green-500 rounded-full live-dot"></span>
                  Atendendo agora
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
